import { supabase } from '../clients/supabaseClient';
import type { FeatureFlag } from '../types';

export async function fetchFeatureFlagsFromDb(): Promise<FeatureFlag[]> {
    const { data, error } = await supabase
        .from('feature_flags')
        .select('*')
        .order('label', { ascending: true });

    if (error) throw error;
    return (data ?? []) as FeatureFlag[];
}

export async function updateFeatureFlagInDb(
    id: string,
    enabled: boolean
): Promise<FeatureFlag> {
    const { data, error } = await supabase
        .from('feature_flags')
        .update({ enabled, updated_at: new Date().toISOString() })
        .eq('id', id)
        .select()
        .single();

    if (error) throw error;
    return data as FeatureFlag;
}